import axios from "axios";
import { translateErrorMessage } from "./errorMessages";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tb_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const formatPrice = (v) => `$${Number(v || 0).toFixed(2)}`;

// Backend image proxy for Discord photos. `w` = lightweight cached thumbnail width; omit for original.
export const bridgeImage = (url, w) => {
    if (!url) return "";
    return `${API}/bridge/image?u=${encodeURIComponent(url)}${w ? `&w=${w}` : ""}`;
};


// Resolve the best available image URL for a product. Backend now dual-writes
// images to object storage (`foto_url`) and still keeps the legacy `foto` field.
// Order of preference: (1) foto_url when the backfill has already run,
// (2) images[0] as a secondary source, (3) the legacy foto blob/URL.
// foto_url may come back as an app-relative path (e.g. /api/products/image/…);
// in that case we prepend REACT_APP_BACKEND_URL so <img src> resolves the API.
export const productImage = (p) => {
    if (!p) return "";
    const url = p.foto_url;
    if (url) {
        if (/^(https?:|data:)/.test(url)) return url;
        if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
        return url;
    }
    const imgs = Array.isArray(p.images) ? p.images : [];
    if (imgs[0]) return imgs[0];
    return p.foto || "";
};

// Detect whether the current session should render English error messages.
// Only users who explicitly picked "en" via the language toggle end up with that
// key in localStorage (SV market never sets it). Reading directly avoids having
// to thread the language through every call site.
const isEnglishSession = () => {
    try { return localStorage.getItem("tb_lang") === "en"; }
    catch { return false; }
};

export const formatApiErrorDetail = (detail) => {
    const en = isEnglishSession();
    if (!detail) return en ? "Something went wrong. Please try again." : "Algo salió mal. Inténtalo de nuevo.";
    if (typeof detail === "string") return translateErrorMessage(detail, en);
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? translateErrorMessage(e.msg, en) : JSON.stringify(e))).join(" ");
    if (detail.msg) return translateErrorMessage(detail.msg, en);
    return String(detail);
};
